import React from 'react';
import { useTranslation } from 'react-i18next';

interface UserRoleProps {
  role: string;
  text?: string;
  size?: 'sm' | 'mid' | 'lg';
}

const UserRoleBadge: React.FC<UserRoleProps> = ({ role, text, size = 'mid' }) => {
  const { t } = useTranslation();

  const badgeColorMap: Record<UserRoleProps['role'], string> = {
    admin: 'danger',
    director: 'primary',
    'pedagogy-director': 'info',
    teacher: 'success',
    student: 'warning',
    guardian: 'secondary',
    user: 'info',
    guest: 'info',
  };

  const iconMap: Record<UserRoleProps['role'], string> = {
    admin: 'ti ti-shield-lock',
    director: 'ti ti-building',
    'pedagogy-director': 'ti ti-school',
    teacher: 'ti ti-user-check',
    student: 'ti ti-user',
    guardian: 'ti ti-users',
    user: 'ti ti-user',
    guest: 'ti ti-user-circle',
  };

  const sizeStyles = {
    sm: { fontSize: '0.75rem', iconSize: '1rem', padding: 'px-2 py-1' },
    mid: { fontSize: '0.875rem', iconSize: '1.2rem', padding: 'px-3 py-1' },
    lg: { fontSize: '1rem', iconSize: '1.5rem', padding: 'px-4 py-2' },
  }[size];

  return (
    <span
      className={`badge badge-soft-${badgeColorMap[role] ?? 'info'} d-inline-flex align-items-center ${sizeStyles.padding} rounded-pill shadow-sm`}
      style={{
        fontSize: sizeStyles.fontSize,
        fontWeight: 500,
        gap: '0.4rem',
        whiteSpace: 'nowrap',
        letterSpacing: '0.3px',
        border: '1px solid rgba(0,0,0,0.05)',
      }}
    >
      <i
        className={`${iconMap[role] ?? 'ti ti-user'}`}
        style={{
          fontSize: sizeStyles.iconSize,
          display: 'inline-flex',
          alignItems: 'center',
        }}
      />
      {text || t(role)}
    </span>
  );
};

export default UserRoleBadge;
